import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Badge } from '@calendly/ui/components/badge'
import { Button } from '@calendly/ui/components/button'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { Link } from '@calendly/ui/components/link'
import { TitleText } from '@calendly/ui/components/typography'

import { useBillingPath } from 'features/billing'

import { BadgeWrapper, Description } from '../styles'

const ScimHelpCenterLink = ({ children }) => (
  <Link href="https://calendly.com/help/scim-user-provisioning-overview" target="_blank" rel="noreferrer noopener">{children}</Link>
)

export const Upgrade = () => {
  const contactSalesPath = useBillingPath('/contact_sales', { interest: 'User provisioning' })

  return (
    <div>
      <BadgeWrapper>
        <Badge type="new">{I18n.t('publisher.billing.tiers.enterprise')}</Badge>
      </BadgeWrapper>
      <FlexLayout direction="column" gap={16}>
        <TitleText level={2} size="medium">{I18n.t('publisher.organization_settings.user_provisioning.upgrade.header')}</TitleText>
        <Description>
          {HtmlParser(I18n.t('publisher.organization_settings.user_provisioning.upgrade.description'), { ScimHelpCenterLink })}
        </Description>
      </FlexLayout>
      <Button as="a" href={contactSalesPath}>
        {I18n.t('publisher.billing.contact_sales.contact_us')}
      </Button>
    </div>
  )
}
